import { FC } from 'react';

interface SwitcherType {
    leftText: string;
    rightText: string;
    id: string;
    uniqueName: string;
    onChange: () => void;
    value: string;
}

const Switcher: FC<SwitcherType> = ({ leftText, rightText, id, uniqueName, onChange, value }) => {
    return (
        <div className="switcher flex align-center">
            <div className="text">{leftText}</div>
            <label htmlFor={id}>
                <input
                    type="checkbox"
                    name={uniqueName}
                    id={id}
                    checked={!!value}
                    onChange={onChange}
                />
                <span>
                    <b />
                </span>
            </label>
            <div className="text">{rightText}</div>
        </div>
    );
};

export default Switcher;
